import {
  Component, EventEmitter, Input,
  Output, SimpleChange
} from '@angular/core';
import { ShowMorePrefixModel } from './show-more-prefix.model';

@Component({
  selector: 'act-show-more-content-box',
  templateUrl: './show-more-content-box.component.html',
  styleUrls: ['./show-more-content-box.component.scss']
})
export class ShowMoreContentBoxComponent {

  private isDisplayAll: boolean = true;

  @Input('showBtn') showBtn: boolean = false;
  @Output('filter') filter: EventEmitter<any> = new EventEmitter();
  @Input() contentClass: string = '-default';

  private _prefix = new ShowMorePrefixModel();
  @Input() set prefix(prefix: any) {
    this._prefix = prefix || this._prefix;
  }

  constructor() { }

  ngOnChanges(changes: { [propertyName: string]: SimpleChange }) {
    if (changes['showBtn']) {
      if (this.showBtn) {
        this.isDisplayAll = this.showBtn ? false : true;
      } else {
        this.isDisplayAll = false;
        this.filter.emit(!this.isDisplayAll);
      }
    }
  }

  switchBtn() {
    this.isDisplayAll = this.isDisplayAll ? false : true;
    this.filter.emit(!this.isDisplayAll);
  }
}



// WEBPACK FOOTER //
// ./src/app/components/show-more-content-box/show-more-content-box.component.ts